<div class="inputs__search">
  <app-autocomplete-dropdown
    #originAutocomplete
    (clearInput)="clearOriginInput()"
    (openChange)="handleOriginDropdownState($event)"
    (selectItem)="selectOrigin($event)"
    [control]="originControl"
    [isPreloaded]="isOriginPreloaded"
    [ngStyle]="{ 'width.%': flightType === 2 ? '100' : '45' }"
    [noResults]="noOriginResults"
    [showLoader]="showOriginLoader"
    [suggestions]="originSuggestions"
    id="origin_autocomplete"
    placeholder="Origen"
  ></app-autocomplete-dropdown>

  <div (click)="swapOriginAndDestination()" class="inputs__search__arrow">
    <img
      [ngClass]="rotateArrows ? 'rotate' : 'not-rotate'"
      alt="Intercambiar lugares"
      src="./assets/svg/arrow-left-right.svg"
    />
  </div>

  <app-autocomplete-dropdown
    #destinationAutocomplete
    (clearInput)="clearDestinationInput()"
    (inputClick)="openDestinationHistory()"
    (openChange)="handleDestinationDropdownState($event)"
    (selectItem)="selectDestination($event)"
    [control]="destinationControl"
    [isPreloaded]="isDestinationPreloaded"
    [ngStyle]="{ 'width.%': flightType === 2 ? '100' : '45' }"
    [noResults]="noDestinationResults"
    [showLoader]="showDestinationLoader"
    [suggestions]="destinationSuggestions"
    id="destination_autocomplete"
    placeholder="Destino"
  ></app-autocomplete-dropdown>
</div>
